// extracted by mini-css-extract-plugin
module.exports = {"basketBarContent":"BasketBar_basketBarContent__2zo7r","basketBar":"BasketBar_basketBar__3BYKg","basketBarText":"BasketBar_basketBarText__2oeX9"};